import { render } from "./RegisterSchool.vue?vue&type=template&id=082ca5dc&ts=true"
import script from "./RegisterSchool.vue?vue&type=script&lang=ts"
export * from "./RegisterSchool.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__